import type { AxiosInstance, AxiosRequestConfig } from 'axios'
import type { ApiResponse } from '~/types'

export function useApi() {
  const { $api } = useNuxtApp()

  const api = $api as AxiosInstance

  async function get<T>(url: string, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
    const { data } = await api.get<ApiResponse<T>>(url, config)
    return data
  }

  async function post<T>(url: string, body?: unknown, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
    const { data } = await api.post<ApiResponse<T>>(url, body, config)
    return data
  }

  async function put<T>(url: string, body?: unknown, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
    const { data } = await api.put<ApiResponse<T>>(url, body, config)
    return data
  }

  async function patch<T>(url: string, body?: unknown, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
    const { data } = await api.patch<ApiResponse<T>>(url, body, config)
    return data
  }

  async function del<T>(url: string, config?: AxiosRequestConfig): Promise<ApiResponse<T>> {
    const response = await api.delete<ApiResponse<T>>(url, config)
    if (response.status === 204 || response.data === '' || response.data == null) {
      return { success: true }
    }
    return response.data
  }

  return { api, get, post, put, patch, del }
}
